export interface User {
  _id: string;
  email: string;
  name: string;
  isActive: boolean;
  roles: string[];
}

export interface Datos {
  id: number;
  alta: Date;
  baja: string;
  estado: string;
}

export interface Direccion {
  calle: string;
  departamento: string;
  depto: string;
  id: number;
  localidad: string;
  numero: string;
  piso: string;
  provincia: string;
}

export class Usuarios {
  id: number;
  mail: string;
  nombre: string;
  apellido: string;
  telefono: string;
  direccion: Direccion;
  documento: string;
  datos: Datos;
  activo: string;
  fotos_id: number;
  tipo: string;
  clave: string;
  total_comprado_sesenta_dias: number;
  numCliente: string;

  constructor(data: any) {
    this.id = data.id;
    this.direccion = data.direccion;
    this.documento = data.documento;
    this.datos = data.datos;
    this.activo = data.activo;
    this.tipo = data.tipo;
    this.clave = data.clave;
    this.fotos_id = data.fotos_id;
    this.apellido = data.apellido;
    this.mail = data.mail;
    this.nombre = data.nombre;
    this.telefono = data.telefono;
    this.numCliente = data.numCliente;
    this.total_comprado_sesenta_dias = data.total_comprado_sesenta_dias;
  }

}
